import { render, staticRenderFns } from "./authcode.vue?vue&type=template&id=328da77c&scoped=true&"
import script from "./authcode.vue?vue&type=script&lang=js&"
export * from "./authcode.vue?vue&type=script&lang=js&"
import style0 from "./authcode.vue?vue&type=style&index=0&id=328da77c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "328da77c",
  null
  
)

export default component.exports